// extracted by mini-css-extract-plugin
export default {"rowData":"progetti_rowData__4FUhI","tr":"progetti_tr__f+yH6"};